import {Payroll, PayrollRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {TableCell} from "@mui/material";
import {dateFromToString} from "../../../../components/utils/dates";
import {useApiManager} from "../../../../components/utils/api";
import {numberToString} from "../../../../components/utils/numbers";

export const PayrollListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<Payroll> = {
		title: "Nóminas ",
		onClick: "/app/admin/employee/payroll",
		headers: [
			{title: "Período"},
			{title: "Persona"},
			{title: "Coste Empresa", align: "right"},
		],
		decorator: (bean: Payroll) => (
			< >
				<TableCell>
					{dateFromToString(bean.periodFrom)} - {dateFromToString(bean.periodTo)}
				</TableCell>
				<TableCell>
					{bean.person.surnames}, {bean.person.name}
				</TableCell>
				<TableCell align={"right"}>
					{bean.person.id != 236 && (
						<>
							{numberToString(bean.costeEmpresa)}
						</>
					)}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(PayrollRestControllerApiFactory);
			return ctrl.pagePayroll(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};